import { deviceType, batteryLevel, voltageLevel } from "../constant";

export const batteryWarning = (car, siteSettingsData) => {
  if (!car.UseVoltage) {
    return siteSettingsData?.GuardianCapable && 
            !car.IsCharging && 
            (car.BatteryLevel > batteryLevel.critical) && 
            (car.BatteryLevel <= batteryLevel.warning);
  }

  else if (car.UseVoltage && car?.DevType === deviceType.FT2) {
    return car?.BatteryVoltage > voltageLevel.critical && car?.BatteryVoltage <= voltageLevel.warning;
  }
};